module.exports = __webpack_public_path__ + "media/site_templates/www.buildersnearme.net.au/images/testimonials-9d1433eeda5d319532dc3eba3dc5e427.jpg";